export const whiteList404 = [new RegExp('/accounts/\\d+/geofence/nearest')];

export function isWhiteListedURL(url) {
  return whiteList404.some((p) => p.test(url));
}
